import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

const propTypes = {
  promoCode: PropTypes.string.isRequired,
};

/**
 * "Free*" price label for a Digital Photo Pass made free by a promo code,
 * explaining the code on hover.
 *
 * @param {Object} props The props.
 * @param {string} props.promoCode The promo code to check out with.
 * @returns {JSX.Element}
 */
const FreePassPromoCodeLabel = ({ promoCode }) => {
  const tooltipId = `free-pass-promo-code-${promoCode}`;

  return (
    <>
      <span
        data-tip={`Free when you check out with promo code "${promoCode}".`}
        data-for={tooltipId}
        data-testid="free-pass-promo-code-label"
      >
        Free*
      </span>
      <ReactTooltip
        id={tooltipId}
        className="text-normal"
        place="top"
        effect="solid"
      />
    </>
  );
};

FreePassPromoCodeLabel.propTypes = propTypes;

export default FreePassPromoCodeLabel;
